import { Space } from 'antd';
import * as React from 'react';
import { useMemo } from 'react';
import styled from 'styled-components';
import { useFormItemScreenReaderLabelAddition } from '../../item/label/useFormItemScreenReaderLabelAddition';
import { SelectOption } from '../SelectInput';
import { StaticInput, StaticInputProps } from '../static/StaticInput';
import { StaticTag } from '../static/StaticTag';

const StaticSelectInput = styled(StaticInput)`
  display: inline-flex;
  padding-right: 3px;
  .ant-input-prefix {
    max-width: 100%;
  }
`;

export interface ISelectReadOnlyProps extends Omit<StaticInputProps, 'value'> {
  options: SelectOption[];
  filterProp: string;
  value: any;
}

export function SelectReadOnly(props: ISelectReadOnlyProps) {
  const { value, options, filterProp, ...inputProps } = props;

  // per ogni valore, ricercare la label
  const selectedOptions = useMemo(() => {
    // le label delle opzioni possono essere un elemento ReactNode
    // o un array di elementi ReactNode, quindi dobbiamo renderizzare un elemento diverso
    const values = Array.isArray(value) ? value : [value];

    return values.map(value => {
      const option = options?.find(opt => opt.value === value);
      return {
        label: option?.label,
        value: option?.value,
      };
    });
  }, [options, value]);

  const labelAddition = useMemo(() => {
    return (
      <>
        {selectedOptions.map(option => (
          <span key={option.value}>{option.label}</span>
        ))}
      </>
    );
  }, [selectedOptions]);

  useFormItemScreenReaderLabelAddition(labelAddition);

  return (
    <StaticSelectInput {...inputProps} value={''}>
      <div>
        <Space wrap size={[2, 4]}>
          {selectedOptions.map(option => (
            <StaticTag aria-hidden="true" key={option.value}>
              {option.label}
            </StaticTag>
          ))}
        </Space>
      </div>
    </StaticSelectInput>
  );
}
